export default __webpack_public_path__ + "static/media/logo-primary.f4b335dc.svg";